import {
  clearCurrentGTId,
  resetScheduling,
  setCurrentGTId,
  toggleSchedulerInfoDrawer,
} from '../reducers/scheduling.reducer';
import { useDispatch, useSelector } from '../store';
import type { RootState, SchedulingState } from '../types';

export const useSchedulingStore = () => {
  const schedulingStore = useSelector<RootState, SchedulingState>((state) => state.scheduling);
  const dispatch = useDispatch();

  return {
    schedulingStore,
    currentGTId: schedulingStore.currentGTId,
    schedulerInfo: schedulingStore.schedulerInfo,
    dispatch,
    setCurrentGTId: (gtId: string) => dispatch(setCurrentGTId(gtId)),
    clearCurrentGTId: () => dispatch(clearCurrentGTId()),
    resetScheduling: () => dispatch(resetScheduling()),
    toggleSchedulerInfoDrawer: (drawer: boolean) => dispatch(toggleSchedulerInfoDrawer({ drawer })),
  };
};
